import { BREAKPOINT_WIDTHS, BreakpointName } from '../../globals/utilities/breakpoints';

type SimpleAccordion = {
  init: () => void;
};

const SimpleAccordion: SimpleAccordion = {
  init() {
    const accordions: NodeListOf<HTMLElement> = document.querySelectorAll('[data-hook=simpleAccordion]');

    accordions?.forEach((accordion) => {
      const accordionButton: HTMLButtonElement | null = accordion.querySelector('[data-hook=simpleAccordion__button]');
      const accordionPanel: HTMLElement | null = accordion.querySelector('[data-hook=simpleAccordion__panel]');

      const defaultOpenBreakpoint = accordion.getAttribute('data-default-open-breakpoint') as BreakpointName | null;
      if (defaultOpenBreakpoint && accordionButton) {
        const minWidth = BREAKPOINT_WIDTHS[defaultOpenBreakpoint];
        if (minWidth && window.matchMedia(`(min-width: ${minWidth}px)`).matches) {
          accordionButton.setAttribute('aria-expanded', 'true');
          accordionPanel?.setAttribute('aria-hidden', 'false');
        }
      }

      accordionButton?.addEventListener('click', () => {
        const newState = accordionButton.getAttribute('aria-expanded') === 'true' ? 'closed' : 'open';
        accordionButton.setAttribute('aria-expanded', newState === 'open' ? 'true' : 'false');
        accordionPanel?.setAttribute('aria-hidden', newState === 'open' ? 'false' : 'true');
      });
    });
  },
};
export default SimpleAccordion;
